/**
 * HALFTONE MODAL TRIGGER - ENHANCED
 * Ensures modal opens correctly when "Jetzt konfigurieren" button is clicked
 *
 * Version: 1.0.0 - 2026-01-30
 */

(function () {
  'use strict';

  // Delegate the click so we survive DOM re-renders (theme/web-components).
  // Use capture to run before other handlers that may stop propagation.
  document.addEventListener(
    'click',
    function (event) {
      const trigger =
        event.target && event.target.closest ? event.target.closest('#start-editing') : null;

      if (!trigger) return;

      event.preventDefault();

      console.log('[Halftone Modal Trigger] Click #start-editing');

      if (window.HalftoneOverlayV2 && typeof window.HalftoneOverlayV2.open === 'function') {
        console.log('[Halftone Modal Trigger] Using HalftoneOverlayV2');
        window.HalftoneOverlayV2.open();
        return;
      }

      console.warn('[Halftone Modal Trigger] HalftoneOverlayV2 missing, using fallback');

      // Fallback: basic open if the controller isn't available
      const modal = document.getElementById('halftone-overlay-container');
      if (!modal) return;
      modal.classList.add('visible');
      modal.style.display = 'flex';
      document.body.classList.add('halftone-modal-open');
    },
    true
  );

  // Auto-open configurator when ?configure=true is in URL
  var params = new URLSearchParams(window.location.search);
  if (params.get('configure') === 'true') {
    var waitForButton = setInterval(function () {
      var btn = document.querySelector('#start-editing');
      if (btn) {
        clearInterval(waitForButton);
        btn.click();
        params.delete('configure');
        var cleanUrl = window.location.pathname +
          (params.toString() ? '?' + params.toString() : '');
        window.history.replaceState({}, '', cleanUrl);
      }
    }, 100);
    setTimeout(function () { clearInterval(waitForButton); }, 5000);
  }
})();
